export enum SearchByTypes {
  codes = "codes",
  CASs = "CASs",
  MFCDs = "MFCDs",
  SMILEs = "SMILEs",
  text = "text",
}
